export default __webpack_public_path__ + "static/green-7121281d15e448d86ff02ee5d2daafe0.mp3";